import { Reducer } from 'interfaces'
import { ExtendedSubscription, SubscriptionDataState } from 'interfaces/subscription'
import { CLEANUP_SUBSCRIPTION_MESSAGES, CANCEL_SUBSCRIPTION, GetSubscriptionAction } from 'actions/subscriptionActions'
import { createFetchableReducer, createEmptyFetchable } from 'helpers/loadableHelpers'
import { CREATE_STRIPE_PAYMENT_METHOD, PATCH_STRIPE_PAYMENT_METHOD, CLEANUP_STRIPE_PATCH } from 'actions/stripeActions'
import { combineReducers } from 'redux'
import { KILL_ALL_FLOATING_PANES, KILL_FLOATING_PANES } from 'actions/floatingPanesActions'
import { WsMessageAction } from 'actions/webSocketActions'
import { DEFAULT_SUBSCRIPTION } from 'fixtures/subscription'
import { Fetchable } from 'interfaces/fetchable'

const getSubscriptionReducer = createFetchableReducer<SubscriptionDataState['info']['data']>()
const info: Reducer<SubscriptionDataState['info']> = (prevState = createEmptyFetchable(), action) => {
  switch (action.type) {
    case GetSubscriptionAction.type:
    case CANCEL_SUBSCRIPTION: {
      const nextState = getSubscriptionReducer(prevState, action)
      return {
        ...nextState,
        data: {
          ...nextState.data,
          can_be_cancelled: action.type === CANCEL_SUBSCRIPTION 
            ? false
            : Boolean(nextState.data?.can_be_cancelled),
        },
      } as Fetchable<ExtendedSubscription | null>
    }

    case PATCH_STRIPE_PAYMENT_METHOD:
    case CREATE_STRIPE_PAYMENT_METHOD: {
      if (action.meta !== 'success') {
        return prevState
      }

      return {
        ...prevState,
        data: {
          ...DEFAULT_SUBSCRIPTION,
          ...prevState.data,
          ...action.payload.response,
        },
      }
    }

    case WsMessageAction.type: {
      if (action.payload.event === 'subscription_changed') {
        return {
          ...prevState,
          data: {
            ...DEFAULT_SUBSCRIPTION,
            ...prevState.data,
            ...action.payload.data,
          },
        }
      }
    }
  }
  return prevState
}


const fetchableReducer = createFetchableReducer<null>()

const stripeCreatePaymentMethod: Reducer<SubscriptionDataState['stripeCreatePaymentMethod']> = (prevState = createEmptyFetchable(), action) => {
  switch (action.type) {
    case CREATE_STRIPE_PAYMENT_METHOD: {
      return fetchableReducer(prevState, action)
    }

    case KILL_ALL_FLOATING_PANES:
    case KILL_FLOATING_PANES: {
      return createEmptyFetchable()
    }
  }

  return prevState
}

const stripePatchPaymentMethod: Reducer<SubscriptionDataState['stripePatchPaymentMethod']> = (prevState = createEmptyFetchable(), action) => {
  switch (action.type) {
    case PATCH_STRIPE_PAYMENT_METHOD: {
      return fetchableReducer(prevState, action)
    }

    case CLEANUP_STRIPE_PATCH: {
      return createEmptyFetchable()
    }
  }

  return prevState
}


const messages: Reducer<SubscriptionDataState['messages']> = (prevState = null, action) => {
  switch (action.type) {
    case PATCH_STRIPE_PAYMENT_METHOD:
    case CREATE_STRIPE_PAYMENT_METHOD: {
      if (action.meta !== 'fail') {
        return prevState
      }

      let { errorExtra } = action.payload
      if (typeof errorExtra === 'string') {
        errorExtra = [errorExtra]
      }
      return errorExtra || null
    }

    case KILL_ALL_FLOATING_PANES:
    case KILL_FLOATING_PANES:
    case CLEANUP_SUBSCRIPTION_MESSAGES: {
      return null
    }

  }
  return prevState
}


export const subscriptionReducer = combineReducers<SubscriptionDataState>({
  info,
  messages,
  stripeCreatePaymentMethod,
  stripePatchPaymentMethod,
})
